/**
 * Media API — binding to the shared createMediaApi(http) factory in
 * packages/common, bound to web's apiClient singleton.
 */

import { apiClient } from "@/lib/api/client";
import { createMediaApi } from "@speakai/common/src/media/api";

export type {
  JobRevision,
  MediaDuration,
  MediaSentimentDocument,
  MediaListFilters,
  MediaCallDetails,
  SourceTranscriptReason,
  SourceTranscriptUnavailable,
  TranslationSourceSummary,
  TranslationSourceHint,
  SourceTranscriptPayload,
  SourceTranscriptResponse,
  MediaItem,
  MediaListResponse,
  MediaDetail,
  UploadRecordingPayload,
  UploadRecordingResponse,
} from "@speakai/common/src/media/types";

export const {
  getMediaList,
  getMediaDetail,
  getTranscript,
  getSourceTranscript,
  getMediaCaption,
  getTranscriptRevisions,
  getTranscriptRevisionSegments,
  getMediaEditorTranscript,
  updateMedia,
  deleteMedia,
  moveMedia,
  setMediaThumbnailImage,
  requestMediaThumbnailFrame,
  uploadRecording,
  bulkDeleteMedia,
  bulkReanalyzeMedia,
  updateMediaRemark,
  updateMediaTagsAndRemark,
  exportMediaMultiple,
  exportMediaSingle,
  exportMediaMultipleFromPanel,
  reanalyzeMediaFull,
  reanalyzeInsights,
  retranscribeMedia,
  reuploadText,
  updateFavorite,
} = createMediaApi(apiClient);
